export const eu: Record<string, string> = {
  'nav.leagues_load_failed': 'Ezin izan dira zure ligak kargatu. Ireki berriro menua berriro saiatzeko.',
  'api.calls_count': '{count} dei erregistratuta',
  'api.clear': 'Deien erregistroa garbitu',
  'api.filter_method': 'Metodoa:',
  'api.latency': 'Latentzia: {ms} ms',
  'api.latency_hint': 'Batez besteko latentzia simulatua: ~180ms · HTTP/2',
  'api.no_calls': 'Ez dago deirik erregistratuta oraindik. Egin edozein ekintza jokoan.',
  'api.payload': 'Eskaeraren Payload-a (Request Body):',
  'api.response': 'Zerbitzariaren Erantzuna (Mocked Response):',
  'api.select_hint': 'Egin klik zerrendako edozein eskaeratan bere payload-a eta erantzun mockeatua JSON formatuan ikusteko.',
  'api.status_ok': 'Egoera: {status} OK',
  'api.subtitle': 'Zerbitzu-geruzarako simulatutako deien denbora errealeko erregistroa',
  'api.time': 'Ordua: {time}',
  'api.title': 'REST Endpoint Kontsola (Mock Responses)',
  'auth.authenticating': 'Zerbitzarian autentifikatzen...',
  'auth.demo_hint': 'Egin klik sarbide azkarrean Manager Ofizial gisa sartzeko aurrez kargatutako datuekin.',
  'auth.email': 'Helbide Elektronikoa',
  'auth.enter_credentials': 'Sartu zure kredentzialak zure klubaren kudeaketan sartzeko.',
  'auth.err_email_required': 'Erabiltzailea edo posta derrigorrezkoa da',
  'auth.err_password_required': 'Pasahitza derrigorrezkoa da',
  'auth.feat_finance': 'Estadioa, modulu komertziala, maileguak eta kontabilitate liburu nagusia',
  'auth.feat_market': 'Fitxaketa merkatua, klausulak eta negoziazio objektiboa',
  'auth.feat_squad': 'Taldearen kudeaketa, taktikak eta harrobia',
  'auth.password': 'Pasahitza',
  'auth.password_required': 'Pasahitza derrigorrezkoa da',
  'auth.quick_access': 'Proba Azkarreko Sarbidea (Kliku 1)',
  'auth.remember_me': 'Saioa gogoratu',
  'auth.submit': 'Managerraren Bulegoan Sartu',
  'auth.subtitle': 'Kirol kudeaketa profesionaleko simulagailua, partida motorrarekin, ekonomiarekin eta zuzeneko merkatuarekin.',
  'auth.user_placeholder': 'erabiltzailea@adibide.eus edo zure erabiltzailea',
  'auth.user_required': 'Erabiltzailea edo posta derrigorrezkoa da',
  'auth.welcome': 'Ongi etorri League of Managers-era',
  'auth.google_continue': 'Jarraitu Google-rekin',
  'auth.google_checking': 'Zure saioa egiaztatzen...',
  'auth.google_err_cancelled': 'Google-ko sarbidea bertan behera utzi duzu.',
  'auth.google_err_expired': 'Saiakera iraungitu da edo jada erabili da. Saiatu berriro.',
  'auth.google_err_not_allowed': 'Kontu hau ez dago gaituta Google-rekin proba egiteko.',
  'auth.google_err_unavailable': 'Ezin izan da saioa hasi. Saiatu berriro.',
  'auth.google_back_to_login': 'Itzuli saio-hasierara',
  'auth.register_title': 'Sortu Manager Kontua',
  'auth.register_subtitle': 'Erregistratu zure kluba zuzentzeko eta League of Managers-en lehiatzeko.',
  'auth.register_btn': 'Sortu kontua',
  'auth.register_creating': 'Kontua sortzen…',
  'auth.repeat_password': 'Berretsi Pasahitza',
  'auth.repeat_password_required': 'Pasahitza errepikatu behar duzu',
  'auth.passwords_must_match': 'Pasahitzak ez datoz bat',
  'auth.password_min_length': 'Pasahitzak gutxienez 8 karaktere izan behar ditu',
  'auth.password_max_length': 'Pasahitzak ezin ditu 128 karaktere baino gehiago izan',
  'auth.email_invalid': 'Sartu baliozko helbide elektroniko bat',
  'auth.email_max_length': 'Postak ezin ditu 254 karaktere gainditu',
  'auth.register_success_title': 'Egiaztatu zure posta',
  'auth.register_success_neutral_msg': 'Erregistroa bidezkoa bada, mezu bat jasoko duzu zure kontua berresteko; jada kontua baduzu, erabili zure ohiko sarbide-metodoa.',
  'auth.resend_btn': 'Berriro bidali berrespen-mezua',
  'auth.resend_wait': 'Berriro bidali {seconds} segundotan',
  'auth.resend_sending': 'Berriro bidaltzen…',
  'auth.resend_sent': 'Kontua berresteke badago, posta berriro bidali dugu.',
  'auth.has_account': 'Jada kontua duzu? Hasi saioa',
  'auth.no_account': 'Ez duzu konturik? Erregistratu',
  'auth.err_email_not_verified': 'Zure helbide elektronikoa oraindik ez da berretsi. Egiaztatu sarrera-ontzia edo eskatu esteka berri bat.',
  'auth.err_invalid_request': 'Berrikusi sartutako datuak. Pasahitzak 8 eta 128 karaktere artean izan behar ditu.',
  'auth.err_rate_limited': 'Eskaera gehiegi egin dituzu. Itxaron pixka bat berriro saiatu aurretik.',
  'auth.err_unavailable': 'Zerbitzua ez dago erabilgarri aldi baterako. Saiatu beranduago.',
  'auth.err_registration_disabled': 'Kontuen erregistroa ez dago erabilgarri une honetan.',
  'auth.verify_title': 'Helbide Elektronikoaren Berrespena',
  'auth.verify_subtitle': 'Sakatu botoia zure manager-kontua aktibatzeko League of Managers-en.',
  'auth.verify_btn': 'Berretsi posta',
  'auth.verify_confirming': 'Zure posta berresten…',
  'auth.verify_success_title': 'Posta arrakastaz berretsi da!',
  'auth.verify_success_desc': 'Zure kontua aktibo dago dagoeneko. Saioa has dezakezu zure posta eta pasahitzarekin.',
  'auth.verify_go_to_login': 'Joan Saioa Hastera',
  'auth.verify_err_invalid_token': 'Berrespen-esteka baliogabea da, iraungi da edo jada erabili da.',
  'auth.verify_err_resend_title': 'Esteka berri bat behar duzu?',
  'auth.verify_err_resend_desc': 'Sartu zure posta aktibazio-esteka berri bat jasotzeko.',
  'auth.verify_enter_email': 'Sartu zure helbide elektronikoa',
  'auth.verify_request_new_link': 'Eskatu esteka berria',
  'auth.verify_missing_token': 'Ez da berrespen-tokenik eman estekan.',
  'club.accounting_version': 'Kontabilitate bertsioa',
  'club.active_loans': 'aktibo',
  'club.available_balance': 'Kutxan eskuragarri dagoen saldoa',
  'club.currency': 'Moneta',
  'club.healthy_accounts': 'Kontu Garbiak',
  'club.ledger_col_amount': 'Zenbatekoa',
  'club.ledger_col_balance': 'Ondoriozko Saldoa',
  'club.ledger_col_concept': 'Kontzeptua',
  'club.ledger_col_date': 'Data',
  'club.ledger_col_origin': 'Jatorria',
  'club.ledger_col_type': 'Mota',
  'club.ledger_desc': 'Kontabilitate-erregistroa',
  'club.ledger_entries': 'erregistratutako ohar',
  'club.ledger_expense': 'GASTUA',
  'club.ledger_income': 'DIRU-SARRERA',
  'club.ledger_title': 'Transakzioak',
  'club.modules_synced': 'Merkataritza eta ustiapen moduluak sinkronizatuta',
  'club.no_ledger_entries': 'Ez dago liburu nagusian erregistratutako oharrik.',
  'club.reserved_balance': 'Bermeak / Konprometitutako Funtsak',
  'club.solvency_desc': 'Erakundearen ondare-kontrol ofiziala. Klubaren finantzak eurotan (€) likidatzen dira zorrotz.',
  'club.solvency_title': 'Kaudimen eta Likidezia Egoera',
  'club.total_balance': 'Ikuskatutako Balantze Osoa',
  'club.treasury_audited': 'Diruzaintza denbora errealean ikuskatua',
  'common.all': 'Guztiak',
  'common.back': 'Itzuli',
  'common.cancel': 'Utzi',
  'common.close': 'Itxi',
  'common.confirm': 'Baieztatu',
  'common.delete': 'Ezabatu',
  'common.edit': 'Aldatu',
  'common.live': 'Zuzenean',
  'common.loading': 'Kargatzen...',
  'common.retry': 'Berriro saiatu',
  'common.save': 'Gorde',
  'common.today': 'Gaur',
  'common.version': 'Bertsioa',
  'common.yesterday': 'Atzo',
  'comp.advance_round': '{round}. Jardunaldira Aurreratu',
  'comp.badge': 'Lehen Maila',
  'comp.box_office': 'Txarteldegiko Diru-bilketa',
  'comp.calendar_title': 'Partiden Egutegia',
  'comp.close': 'Itxi',
  'comp.club_col': 'Kluba',
  'comp.col_club': 'Kluba',
  'comp.col_dg': 'DA',
  'comp.col_form': 'Forma',
  'comp.col_gc': 'GK',
  'comp.col_gf': 'GA',
  'comp.col_pe': 'BB',
  'comp.col_pg': 'II',
  'comp.col_pj': 'JP',
  'comp.col_pos': '#',
  'comp.col_pp': 'GG',
  'comp.col_pts': 'Pts',
  'comp.current_round': 'Jardunaldia martxan:',
  'comp.final_score': 'Azken Emaitza',
  'comp.finished': 'AMATUTA',
  'comp.form_col': 'Forma',
  'comp.goalscorers': 'Goleatzaileak',
  'comp.group_id_prefix': 'Taldearen IDa: ',
  'comp.group_label': 'Taldea',
  'comp.in_progress': 'JOKATZEN',
  'comp.league_desc': '20 klubeko liga erregularra · 38 jardunaldi joan-etorrian · 4 jaitsiera zuzen.',
  'comp.legend_champions': 'Champions League',
  'comp.legend_conf': '7. Conference Liga',
  'comp.legend_conference': 'Conference League',
  'comp.legend_direct_promotion': 'Igoera zuzena',
  'comp.legend_europa': 'Europa League',
  'comp.legend_playoff': 'Igoera kanporaketa',
  'comp.legend_rel': '17-20. Zuzeneko Jaitsiera',
  'comp.legend_relegation': 'Jaitsiera',
  'comp.legend_ucl': '1-4. Txapeldunen Liga',
  'comp.legend_uel': '5-6. Europa Liga',
  'comp.live_standings': 'Sailkapena Zuzenean',
  'comp.loading_fixtures': 'Jardunaldiko partidak kargatzen...',
  'comp.loading_round': 'Jardunaldia kargatzen...',
  'comp.loading_standings': 'Taldearen sailkapena kargatzen...',
  'comp.match_detail': 'Partidaren Xehetasuna',
  'comp.match_detail_title': 'Partidaren Xehetasuna',
  'comp.next_round': 'Hurrengo jardunaldia',
  'comp.no_fixtures': 'Ez dago partidarik programatuta jardunaldi honetarako.',
  'comp.official_calendar': 'Egutegi ofiziala',
  'comp.prev_round': 'Aurreko jardunaldia',
  'comp.refresh_standings': 'Eguneratu sailkapena zuzenean',
  'comp.round_header': '{current}. Jardunaldia ({total}-tik)',
  'comp.round_of': '/',
  'comp.round_prefix': 'Jardunaldia',
  'comp.scorers': 'Gol-egileak',
  'comp.simulate_round': '{round}. Jardunaldia Simulatu',
  'comp.spectators': 'Ikusleak',
  'comp.standings_title': 'Zuzeneko Sailkapena',
  'comp.status': 'Egoera',
  'comp.subtitle': '20 klubeko liga erregularra · 38 jardunaldi joan-etorrian · 4 jaitsiera zuzen.',
  'comp.ticket_revenue': 'Txarteldegiko Diru-bilketa',
  'comp.tiebreaker': 'Berdinketa-hautslea: Pts · DG · GF',
  'comp.tiebreaker_legend': 'Berdinketa-hautsia: Pts · DG · GF',
  'comp.title': 'Txapelketa Ofiziala',
  'comp.you': 'ZU',
  'comp.you_badge': 'ZU',
  'dashboard.away': 'Kanpokoa',
  'dashboard.away_badge': 'Ligako Aurkaria',
  'dashboard.current_position': 'Zure posizioa: {pos}. sailkatua {pts} punturekin',
  'dashboard.edit_lineup': 'Hamaikakoa Aldatu',
  'dashboard.forecast_attendance': 'Aurreikusitako Asistentzia',
  'dashboard.forecast_revenue': 'Aurreikusitako Diru-sarrerak',
  'dashboard.home': 'Etxekoa',
  'dashboard.kpi_budget': 'Fitxaketetarako Aurrekontua',
  'dashboard.kpi_budget_sub': 'Eskura dauden funts libreak',
  'dashboard.kpi_stadium': 'Estadioaren Edukiera',
  'dashboard.kpi_stadium_sub': 'Gaur egungo edukiera',
  'dashboard.kpi_staff': 'Talde Teknikoaren Maila',
  'dashboard.kpi_staff_sub': '4 prestatzaileen batez besteko izarrak',
  'dashboard.kpi_ticket': 'Sarrera Orokorraren Prezioa',
  'dashboard.kpi_ticket_sub': 'Denboraldirako ezarrita',
  'dashboard.lineup_incomplete': 'Hamaikako osatugabea ({current}/11 hautatuta)',
  'dashboard.lineup_ready': 'Hamaikakoa osatuta eta prest',
  'dashboard.lineup_unavailable': 'Ezin izan da hamaikakoa kontsultatu',
  'dashboard.local_badge': 'Zure Kluba',
  'dashboard.news_count_plural': 'albiste',
  'dashboard.news_count_single': 'albiste',
  'dashboard.news_desc': 'Azken mugimendu ofizialak, baieztatutako transferentziak eta txapelketaren gaurkotasuna',
  'dashboard.news_empty': 'Ez dago albisterik edo fitxaketarik erregistratuta txapelketa honetan une honetan.',
  'dashboard.news_live': 'Zuzenean',
  'dashboard.news_loading': 'Ligako albisteak eta fitxaketak kargatzen...',
  'dashboard.news_title': 'Ligako Albisteak eta Fitxaketak',
  'dashboard.news_today': 'GAUR',
  'dashboard.news_view_market': 'Merkatua Ikusi',
  'dashboard.news_yesterday': 'ATZO',
  'dashboard.next_match': 'Hurrengo Partida ({round}. Jardunaldia)',
  'dashboard.play_round': '{round}. Jardunaldia Jokatu',
  'dashboard.quick_finance_desc': 'Handitu harmailak, hobetu modulu komertzialak, kontratatu prestatzaileak eta kudeatu kreditu-lerroak.',
  'dashboard.quick_finance_title': 'Estadioa eta Finantzak',
  'dashboard.quick_market_desc': 'Fitxatu agente libreak, exekutatu etete-klausulak edo jarri salgai jokalari transferigarriak.',
  'dashboard.quick_market_title': 'Fitxaketa Merkatua',
  'dashboard.quick_squad_desc': 'Ezarri formazio taktikoa (4-3-3, 4-4-2, etab.), esleitu dortsalak eta doitu partidako hamaikakoa.',
  'dashboard.quick_squad_title': 'Taldea eta Hamaikako Titularra',
  'dashboard.retry': 'Berriro Saiatu',
  'dashboard.season_info': '2026/27 Denboraldia · {round}. Jardunaldia ({total}-tik)',
  'dashboard.see_results': 'Emaitzak eta Sailkapena Ikusi',
  'dashboard.stadium_label': 'Estadioa',
  'dashboard.standings_full': 'Taula osoa ikusi',
  'dashboard.standings_title': 'Sailkapena',
  'dashboard.starters_count': 'Hamaikako Titularra',
  'dashboard.status_closed': 'Itxita',
  'dashboard.status_label': 'Egoera',
  'dashboard.status_locked': 'Blokeatuta (Prest)',
  'dashboard.status_open': 'Irekita',
  'dashboard.status_scored': 'Jokatuta',
  'leagues.acronym_label': 'Akronimoa (3 hizki)',
  'leagues.active_badge': 'Liga Aktiboa',
  'leagues.active_game': 'Jokoa martxan',
  'leagues.cancel': 'Utzi',
  'leagues.club_name_in_league': 'Zure Klubaren Izena Liga Honetan',
  'leagues.code_placeholder': 'Adib. PRIV-88219',
  'leagues.code_prefix': 'Kodea',
  'leagues.create_action': 'Liga Sortu',
  'leagues.create_and_join': 'Kluba Sortu eta Batu',
  'leagues.create_btn': 'Liga Pribatua Sortu',
  'leagues.create_modal_title': 'Liga Pribatu Berria Sortu',
  'leagues.create_new_league': 'Liga Berria Sortu',
  'leagues.enter_club': 'Klubean Sartu',
  'leagues.enter_club_placeholder': 'Sartu zure klubaren izena (adib. Burbia FC)',
  'leagues.enter_code': 'Sartu gonbidapen-kodea:',
  'leagues.enter_league': 'Ligan Sartu',
  'leagues.error_title': 'Errorea txapelketak kontsultatzean',
  'leagues.global_competition': 'Txapelketa Orokorra',
  'leagues.global_tab': 'Liga Globalak',
  'leagues.invite_code_label': 'Gonbidapen Kodea (adib. PRIV-9872)',
  'leagues.join_action': 'Bat Egin',
  'leagues.join_closed': 'IZEN-EMATEA ITXITA',
  'leagues.join_code_btn': 'Kodearekin Bat Egin',
  'leagues.join_modal_title': 'Liga Pribatuan Sartu',
  'leagues.join_open': 'IZEN-EMATEA ZABALIK',
  'leagues.join_with_code': 'Batu Kodearekin',
  'leagues.league_name': 'Ligaren Izena',
  'leagues.league_name_label': 'Ligaren Izena',
  'leagues.main_league': 'Liga Nagusia',
  'leagues.managing_club': 'Zuzentzen ari zara:',
  'leagues.members': 'manager',
  'leagues.my_competitions': 'Nire Txapelketak eta Liga Aktiboak',
  'leagues.no_private': 'Ez duzu liga pribatu aktiborik une honetan. Sortu bat edo sartu kode baten bidez!',
  'leagues.no_private_leagues': 'Oraindik ez zara liga pribatu bateko kide',
  'leagues.no_private_leagues_desc': 'Sortu zure lagun-liga jardunaldiz jardunaldi arau eta fitxaketa propioekin lehiatzeko, edo batu gonbidapen kodearekin.',
  'leagues.not_available': 'Ez dago eskuragarri',
  'leagues.official_badge': 'OFIZIALA',
  'leagues.official_competition': 'Sistemaren Txapelketa Ofiziala',
  'leagues.official_desc': 'Eman izena txapelketa orokorrean zure kluba sortuz. Maila ofizialen sisteman lehiatuko zara igoera, jaitsiera eta ziklo lehiakorrekin.',
  'leagues.participants_count': 'Parte-hartzaile Kopurua',
  'leagues.play_league': 'Liga hau jokatu',
  'leagues.primary_color': 'Kolore Nagusia',
  'leagues.private_disabled': 'Liga pribatuak desgaituta daude denboraldi honetan.',
  'leagues.private_leagues': 'Lagunarteko Liga Pribatuak',
  'leagues.private_tab': 'Liga Pribatuak',
  'leagues.registering_club': 'Kluba erregistratzen...',
  'leagues.registrations_not_open': 'Izen-emateak ez daude zabalik txapelketa orokorrerako une honetan.',
  'leagues.resume_game': 'Jokoarekin Jarraitu (Dashboard)',
  'leagues.round_of': '{current}. Jardunaldia ({total}-tik)',
  'leagues.selection_desc': 'Aukeratu lehiatu nahi duzun liga. Txapelketa bakoitzak zure kluba, taldea, ekonomia eta emaitzak modu isolatuan kudeatzen ditu.',
  'leagues.subtitle': 'Aukeratu zure txapelketa ofiziala edo sartu lagunekin liga pribatu batean.',
  'leagues.teams': 'Taldeak',
  'leagues.title': 'Liga eta Txapelketen Zentroa',
  'leagues.validate_and_enter': 'Balioztatu Kodea eta Sartu',
  'leagues.your_club': 'Zure Kluba',
  'loans.active': 'aktibo',
  'loans.amount_label': 'Maileguaren Zenbatekoa (M€)',
  'loans.desc': 'Eskatu 25 M€ arteko finantzaketa urteko %6ko interes-tasa finkoan.',
  'loans.instalment': 'Kuota denboraldiko',
  'loans.max_credit_capacity': 'Gehienezko Kreditu Gaitasuna',
  'loans.request_btn': 'Eskatu Berehalako Emakida',
  'loans.season_singular': 'Denboraldia',
  'loans.seasons_plural': 'Denboraldi',
  'loans.term_label': 'Amortizazio Epea (Denboraldiak)',
  'loans.title': 'Banku Kreditu Lerroa',
  'loans.total_repay': 'Guztira itzultzeko (%6 int.)',
  'loans.year_suffix': 'urte',
  'market.add_watchlist': 'Zorroan Gehitu',
  'market.available_balance': 'Fitxaketetarako Saldo Erabilgarria',
  'market.badge': 'Merkatua, Eskaintzak eta Zorroa',
  'market.balance': 'Fitxaketetarako Saldo Erabilgarria',
  'market.buyout': 'Klausulazoa',
  'market.daily_bidding': 'Eguneko Lizitazioa',
  'market.closes_at': 'Lizitazioaren itxiera',
  'market.cancel': 'Utzi',
  'market.cancel_offer': 'Eskaintza Utzi',
  'market.club_balance': 'Klubaren Saldoa',
  'market.contract_years': 'Iraupena (Urteak)',
  'market.desc': 'Kontratuen negoziazio objektiboa, eskaintza aktiboen egoera eta jarraipeneko futbolarien zorroa.',
  'market.empty_market': 'Ez da futbolaririk aurkitu hautatutako iragazkiekin.',
  'market.error_funds_reservation_rejected': 'Funtsen erreserba baztertuta. Saldo nahikorik ez eskaintza aurkezteko.',
  'market.error_funds_reservation_rejected_details': 'Saldo nahikorik ez eskaintza aurkezteko. {requestedAmount} behar dituzu eta {availableAmount} dituzu eskuragarri.',
  'market.error_insufficient_funds': 'Saldo nahikorik ez eskaintza aurkezteko. {requestedAmount} behar dituzu eta {availableAmount} dituzu eskuragarri.',
  'market.eval_accept': 'Futbolariak proposamen hau onartuko du',
  'market.eval_reject': 'Jokalariarentzat ez da nahikoa',
  'market.filter_all': 'Guztiak',
  'market.filter_att': 'AUR',
  'market.filter_def': 'ATZ',
  'market.filter_gk': 'ATZ',
  'market.filter_mid': 'ERD',
  'market.free_badge': 'Agente Librea',
  'market.loading_agents': 'kargatzen...',
  'market.modal_edit_title': '{name}-(r)entzako Eskaintza Aktiboa Aldatu',
  'market.modal_title': '{name}-(r)i Kontratu Proposamena',
  'market.negotiate': 'Kontratua Negoziatu',
  'market.no_offers': 'Ez duzu transferentzia eskaintza aktiborik une honetan.',
  'market.no_watchlist': 'Zure jarraipen-zorroa hutsik dago. Markatu futbolariak jarraitzeko.',
  'market.offered_clause': 'Etete-Klausula Berria (M€)',
  'market.offered_salary': 'Proposatutako Urteko Soldata (M€)',
  'market.offers_all': 'Eskaintza Guztiak',
  'market.offers_market_targets': 'Merkatuko Helburuak',
  'market.offers_sent': 'Nire Eskaintza Igorriak',
  'market.only_free': 'Libreak Bakarrik',
  'market.remove_sale': 'Transferigarrietatik Kendu',
  'market.remove_watchlist': 'Zorrotik Kendu',
  'market.required_funds': 'Hasierako Kostu Osoa',
  'market.search_placeholder': 'Futbolaria bilatu...',
  'market.signing_bonus': 'Fitxaketa Saria (M€)',
  'market.submit_offer': 'Eskaintza Formalizatu',
  'market.subtab_active_offers': 'Eskaintza Aktiboak',
  'market.subtab_history_offers': 'Eskaintzen Historia',
  'market.history_title': 'Jokalari Askeen Eskaintzen Historia',
  'market.history_desc': 'Aurkeztutako eskaintzen, lizitazioen ebazpenen eta irabazitako edo galdutako eskaintzen erregistro historikoa.',
  'market.history_filter_all': 'Eskaintza Guztiak',
  'market.history_filter_won': 'Irabaziak',
  'market.history_filter_lost': 'Galduak',
  'market.history_filter_cancelled': 'Utzitakoak',
  'market.history_won_badge': 'Fitxaketa Irabazia',
  'market.history_lost_badge': 'Eskaintza Gainditua',
  'market.history_cancelled_badge': 'Eskaintza Utzia',
  'market.rejection_reason_title': 'Baztertzeko arrazoia',
  'market.rejection_reason_ACCEPTED_OTHER_CLUB': 'Beste klub baten eskaintza onartu du',
  'market.rejection_reason_RELEASE_CLAUSE_TOO_HIGH': 'Erreskisio klausula altuegia',
  'market.rejection_reason_ECONOMIC_OFFER_TOO_LOW': 'Eskaintza ekonomiko eskasa',
  'market.history_empty': 'Ez da eskaintzarik aurkitu historian hautatutako irizpideekin.',
  'market.history_total_won': 'Irabazitako Fitxaketak',
  'market.history_total_lost': 'Galdutako Eskaintzak',
  'market.history_total_cancelled': 'Utzitakoak',
  'market.history_total_invested': 'Irabazitako Inbertsioa',
  'market.history_search_placeholder': 'Iragazi futbolariaren izenaren arabera...',
  'market.subtab_market': 'Merkatua',
  'market.subtab_my_sales': 'Nire Transferigarriak',
  'market.subtitle': 'Kontratuen eta etete-klausulen negoziazio objektiboa funtsen kontrolarekin.',
  'market.tab_market': 'Jokalariak',
  'market.tab_offers': 'Eskaintzak',
  'market.tab_watchlist': 'Zorroa',
  'market.title': 'Fitxaketen eta Kontratazioen Merkatua',
  'market.transfer_fee': 'Klubari Transferentzia Prezioa (M€)',
  'market.transfer_offer': 'Eskaintza Formala',
  'market.update_offer': 'Aldaketak Gorde',
  'match.away': 'Kanpokoa',
  'match.badge': 'Partiden Simulazioa',
  'match.batch_notice': 'Backend-ean automatizatutako batch kudeaketa',
  'match.col_goals': 'Golak',
  'match.col_player': 'Futbolaria',
  'match.col_points': 'Fantasy Puntuak',
  'match.col_pos': 'Pos',
  'match.col_reds': 'Gorriak',
  'match.col_stars': 'Prentsa Izarrak (1-5★)',
  'match.col_yellows': 'Horiak',
  'match.cycle_title': 'Jardunaldiaren Zikloko Faseak',
  'match.editorial_desc': 'Puntuazio ofizialak (1-5 izar) eta jardunaldiko fantasy puntuak kalkulatzeko gertaerak.',
  'match.editorial_title': 'Kirol Prentsaren Panel Editoriala',
  'match.home': 'Etxekoa',
  'match.match_attendance': 'Erregistratutako Asistentzia:',
  'match.match_goals': 'Partidako Golak:',
  'match.mod_attendance': 'Ingurune Presioa / Etxeko Edukiera',
  'match.mod_attendance_desc': 'Estadioaren okupazio-ehunekoagatiko bonusa',
  'match.mod_momentum': 'Inertzia Positiboa (Momentum)',
  'match.mod_momentum_desc': 'Azken 5 partidetako garaipen bolada',
  'match.mod_staff': 'Talde Teknikoaren Prestakuntza',
  'match.mod_staff_desc': 'Talde teknikoaren batez besteko izarrak',
  'match.next_btn': 'Hurrengo Jardunaldira Aurreratu',
  'match.not_sent_off': 'Ez',
  'match.phase1_desc': 'Hamaikako Irekia',
  'match.phase2_desc': 'XI Izoztua',
  'match.phase3_desc': 'Puntuak Kalkulatuta',
  'match.phase4_desc': 'Jardunaldia Itxita',
  'match.publish_btn': 'Kalifikazio Ofizialak Argitaratu',
  'match.sent_off': 'Kanporatua',
  'match.simulate_btn': '{round}. Jardunaldia Kalkulatu eta Simulatu',
  'match.subtitle': 'Jardunaldiaren zikloa: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Kirol errendimendua.',
  'match.tab_editorial': 'Prentsaren Kalifikazioak',
  'match.tab_engine': 'Errendimendu Aldatzaileak',
  'match.tactical_desc': 'Simulazio motorrak aplikatutako faktore biderkatzaileen kalkulua.',
  'match.tactical_title': 'Taktika eta Errendimendu Aldatzaileak',
  'match.ticket_revenue': 'Txarteldegiko Diru-bilketa:',
  'match.title': 'Jardunaldiaren Zentroa & Match Engine',
  'match.user_fixture_title': 'Zure Klubaren Partida {round}. Jardunaldian',
  'matches.away_label': 'Kanpokoa',
  'matches.batch_info': 'Backend automatizatutako batch kudeaketa',
  'matches.col_fantasy_pts': 'Fantasy Puntuak',
  'matches.col_goals': 'Golak',
  'matches.col_player': 'Futbolaria',
  'matches.col_pos': 'Pos',
  'matches.col_press_stars': 'Prentsa Izarrak (1-5★)',
  'matches.col_reds': 'Gorriak',
  'matches.col_yellows': 'Horiak',
  'matches.desc': 'Jardunaldiaren zikloa: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Kirol errendimenduaren eta puntuazioen kudeaketa.',
  'matches.editorial_desc': 'Puntuazio ofizialak (1-5 izar) eta gertaerak jardunaldiko fantasy puntuak kalkulatzeko.',
  'matches.editorial_title': 'Kirol Prentsaren Editore Panela',
  'matches.home_label': 'Etxekoa',
  'matches.lineup_frozen': 'XI Izoztua',
  'matches.lineup_open': 'Hamaikakoa Zabalik',
  'matches.match_goals': 'Partidako Golak',
  'matches.mod_attendance': 'Giro Presioa / Tokiko Edukiera',
  'matches.mod_attendance_desc': 'Estadioaren okupazio ehunekoagatik hobaria',
  'matches.mod_momentum': 'Inertzia Positiboa (Momentum)',
  'matches.mod_momentum_desc': 'Azken 5 partidetako garaipen bolada',
  'matches.mod_staff': 'Talde Teknikoaren Prestaketa',
  'matches.mod_staff_desc': 'Talde teknikoaren batez besteko izarrak',
  'matches.not_sent_off': 'Ez',
  'matches.performance_mods': 'Errendimendu Aldatzaileak',
  'matches.phase': 'Fasea',
  'matches.phases_title': 'Jardunaldi Zikloaren Faseak',
  'matches.points_calculated': 'Puntuak Kalkulatuta',
  'matches.press_ratings': 'Prentsaren Kalifikazioak',
  'matches.publish_ratings': 'Kalifikazio Ofizialak Argitaratu',
  'matches.recorded_attendance': 'Erregistratutako Asistentzia',
  'matches.round_closed': 'Jardunaldia Itxita',
  'matches.sent_off': 'Kaleratua',
  'matches.simulation_badge': 'Partiden Simulazioa',
  'matches.spectators_suffix': 'ikusle',
  'matches.tactical_mods_desc': 'Hurrengo partidarako simulazio motorrak aplikatutako biderkatzaileak kalkulatzea.',
  'matches.tactical_mods_title': 'Taktika eta Errendimendu Aldatzaileak',
  'matches.ticket_collection': 'Txarteldegiko Diru-bilketa',
  'matches.title': 'Jardunaldi Zentroa & Match Engine',
  'matches.user_fixture_title': 'Zure Klubaren Partida Jardunaldian',
  'nav.all_leagues': 'Guztiak ikusi / Beste liga batean sartu...',
  'nav.api': 'API',
  'nav.budget': 'Aurrekontua',
  'nav.club': 'Kluba',
  'nav.news': 'Albisteak',
  'nav.competition': 'Txapelketa',
  'nav.competition_context': 'Txapelketaren Testuingurua',
  'nav.credits': 'Kredituak (CR)',
  'nav.dark_mode_enabled': 'Modu Iluna gaituta',
  'nav.dark_mode_title': 'Modu Iluna / Argia',
  'nav.dashboard': 'Dashboard',
  'nav.language': 'Hizkuntza',
  'nav.light_mode_enabled': 'Modu Argia gaituta',
  'nav.logout': 'Saioa Itxi',
  'nav.market': 'Merkatua',
  'nav.matchengine': 'Jardunaldia',
  'nav.next_matchday': 'J{round}-ra Aurreratu',
  'nav.settings': 'Ezarpenak',
  'nav.simulate': 'J{round} Simulatu',
  'nav.squad': 'Taldea',
  'nav.stadium': 'Kluba',
  'nav.switch_league': 'Liga aldatu',
  'nav.toggle_theme_dark': 'Modu Iluna',
  'nav.toggle_theme_light': 'Modu Argia',
  'settings.lang_desc': '4 hizkuntza ofizialetan eskuragarri (Español, Català, Galego eta Euskara).',
  'settings.lang_title': 'Plataformaren Hizkuntza Hautatu',
  'settings.notifications_desc': 'Informazio eta arrakasta oharrak erakutsi (desgaituz gero, akatsak bakarrik agertuko dira).',
  'settings.notifications_disabled': 'Akatsak Bakarrik',
  'settings.notifications_enabled': 'Gaituta',
  'settings.notifications_title': 'Sistemaren Jakinarazpenak',
  'settings.profile_club': 'Esleitutako Gaur egungo Kluba',
  'settings.profile_desc': 'Erabiltzaile-kontuaren datuak eta sarbide-kredentzialak.',
  'settings.profile_email': 'Harremanetarako Posta',
  'settings.profile_info': 'Managerraren Informazioa',
  'settings.profile_logout': 'Saio Ofiziala Itxi',
  'settings.profile_name': 'Izen Ofiziala',
  'settings.profile_role': 'Sistemako Rola',
  'settings.profile_version': 'Plataformaren Bertsioa',
  'settings.separation_desc': 'Klubaren diruzaintza erabiltzailearen kredituetatik erabat bereizita dago. Zure kreditu-zorro pertsonala (CR) Ezarpenetan kudeatzen da.',
  'settings.separation_title': 'Funtsen Bereizketa',
  'settings.subtitle': 'Konfigurazioa, hobespenak eta kreditu pertsonalen Wallet-a',
  'settings.tab_preferences': 'Hobespenak',
  'settings.tab_profile': 'Profila',
  'settings.tab_wallet': 'Wallet (CR)',
  'settings.theme_dark': 'Modu Iluna (Gaua)',
  'settings.theme_desc': 'Argiztapen baxurako optimizatutako modu ilunaren eta argiaren artean aldatu.',
  'settings.theme_light': 'Modu Argia (Eguna)',
  'settings.theme_title': 'Aplikazioaren Ikus-gaia',
  'settings.title': 'Managerraren Ezarpenak',
  'settings.wallet_balance': 'Saldoa Wallet-ean',
  'settings.wallet_benefit_analytics': 'Analisi-modulu aurreratuak',
  'settings.wallet_benefit_fee': 'Federazio-lizentziaren hileko kuota',
  'settings.wallet_benefit_leagues': 'Managerren arteko VIP ligak',
  'settings.wallet_best_value': 'Balio Onena',
  'settings.wallet_desc': 'Kreditu pertsonalak, klubeko diruzaintzatik independenteak.',
  'settings.wallet_explanation': 'Kredituak (CR) zure kontu pertsonalari dagozkio eta ez dira klubaren funtsekin edo aurrekontuarekin nahasten.',
  'settings.wallet_monthly_fee': 'Lizentziaren hileko kuota',
  'settings.wallet_open': 'Wallet Kudeatu',
  'settings.wallet_pay_fee': 'Hileko Kuota Ordaindu (-100 CR)',
  'settings.wallet_personal_funds': 'Funts Pertsonalak',
  'settings.wallet_popular': 'Ezaguna',
  'settings.wallet_recharge': 'Kredituak Birkargatu',
  'settings.wallet_recharge_btn': '{cr} CR Birkargatu',
  'settings.wallet_recharge_instant': 'Berehalako birkarga zorroan',
  'settings.wallet_title': 'Managerraren Wallet-a (CR)',
  'squad.age': 'urte',
  'squad.auto_pick': 'Hamaikako Automatikaria',
  'squad.badge_management': 'Hamaikakoaren Kudeaketa',
  'squad.cancel': 'Utzi',
  'squad.clause': 'Klausula',
  'squad.col_actions': 'Ekintzak',
  'squad.col_age': 'Adina',
  'squad.col_clause': 'Klausula',
  'squad.col_number': '#',
  'squad.col_ovr': 'OVR',
  'squad.col_player': 'Futbolaria',
  'squad.col_pos': 'Pos',
  'squad.col_salary': 'Soldata',
  'squad.col_status': 'Egoera',
  'squad.confirm_renew': 'Berritzea Baieztatu',
  'squad.desc': 'Zehazki 11 titular Jardunaldirako. Zuzeneko aldaketarik gabe.',
  'squad.formation': 'Formazioa',
  'squad.lock_xi': 'XI Blokeatu',
  'squad.locked_xi': 'XI Blokeatuta',
  'squad.new_clause': 'Klausula Berria (M€)',
  'squad.new_salary': 'Urteko Soldata Berria (M€)',
  'squad.new_years': 'Kontratu Urteak',
  'squad.ovr': 'OVR Batez bestekoa',
  'squad.pos_def': 'Atzelaria',
  'squad.pos_del': 'Aurrelaria',
  'squad.pos_df': 'ATZ',
  'squad.pos_fw': 'AUR',
  'squad.pos_gk': 'ATZ',
  'squad.pos_med': 'Erdilaria',
  'squad.pos_mf': 'ERD',
  'squad.pos_por': 'Atezaina',
  'squad.put_transferable': 'Salgai jarri',
  'squad.remove_transferable': 'Salmentatik kendu',
  'squad.renew_contract': 'Kontratua Berritu',
  'squad.renew_modal_title': 'Kontratu Berritzea',
  'squad.salary': 'Urteko Soldata',
  'squad.save_lineup': 'Gorde',
  'squad.saved': 'Gordeta',
  'squad.saving': 'Gordetzen...',
  'squad.starters_count': 'Titularrak',
  'squad.starting_xi': 'Hamaikako Titularra ({count}/11)',
  'squad.substitutes': 'Aulkia eta Erreserbak ({count})',
  'squad.subtitle': 'Konfiguratu zure taktika, formazioa eta hamaikakoa hurrengo jardunaldirako.',
  'squad.tactical_board': 'Formazioa',
  'squad.title': 'Taldea eta Taktika',
  'squad.transfer_status': 'Egoera',
  'squad.transferable': 'Transferigarria',
  'squad.years': 'urte',
  'stadium.attendance_sim_note': 'Prezioaren eta egungo instalazioen araberako estimazioa, sailkapen neutralarekin. Merkataritza-sarrerek gutxi gorabeherako tarifak erabiltzen dituzte; benetako emaitza alda daiteke.',
  'stadium.attendance_sim_title': 'Aurreikusitako Edukieraren Simulazioa',
  'stadium.badge': 'Azpiegitura eta Finantzak',
  'stadium.cafeteria_desc': 'Atsedenaldietan janari eta edarien salmenta handitzen du.',
  'stadium.cafeteria_title': 'Kafetegiak eta Ostalaritza',
  'stadium.capacity_desc': 'Handitu estadioaren edukiera txarteldegian diru-sarrera handiagoak sortzeko.',
  'stadium.capacity_label': 'Edukiera',
  'stadium.capacity_title': 'Harmailak eta Edukiera Handitzea',
  'stadium.capacity_upgrade_title': 'Harmailak eta Edukiera Handitzea',
  'stadium.commercial_modules_title': 'Merkataritza Moduluak eta Ustiapena',
  'stadium.confirm_pricing': 'Berretsi Hurrengo Partidako Prezioak',
  'stadium.confirm_tickets': 'Hurrengo Partidarako Prezioak Baieztatu',
  'stadium.current': 'Gaur egungoa',
  'stadium.current_tier': 'Indarreko Edukiera',
  'stadium.desc': 'Prezioak, edukiera, modulu komertzialak, talde teknikoa, banku-kredituak eta liburu nagusia (Ledger).',
  'stadium.economy_tier': 'Ekonomikoa',
  'stadium.est_attendance': 'Aurreikusitako Okupazioa:',
  'stadium.expense': 'GASTUA',
  'stadium.general_ticket': 'Sarrera Orokorraren Prezioa',
  'stadium.general_ticket_price': 'Sarrera Orokorraren Prezioa',
  'stadium.income': 'SARRERA',
  'stadium.ledger_amount': 'Zenbatekoa',
  'stadium.ledger_balance': 'Ondoriozko Saldoa',
  'stadium.ledger_concept': 'Kontzeptua',
  'stadium.ledger_date': 'Data',
  'stadium.ledger_desc': 'Kontabilitate-erregistroa',
  'stadium.ledger_entries': '{count} ohar erregistratuta',
  'stadium.ledger_title': 'Transakzioak',
  'stadium.ledger_type': 'Mota',
  'stadium.level': 'Maila',
  'stadium.loan_amount': 'Maileguaren Zenbatekoa (M€)',
  'stadium.loan_apply': 'Berehalako Emakida Eskatu',
  'stadium.loan_desc': 'Gehienez 25 M€ arteko finantzaketa eskatu urteko % 6ko interes finkoan.',
  'stadium.loan_installment': 'Kuota denboraldiko:',
  'stadium.loan_title': 'Banku-kreditu Lerroa',
  'stadium.loan_total': 'Itzuli beharrekoa guztira (% 6ko interesarekin):',
  'stadium.loan_years': 'Amortizazio Epea (Denboraldiak)',
  'stadium.max_level': 'Gehienezko Maila',
  'stadium.merchandising_desc': 'Kamiseta eta bufanda ofizialen salmenta partida egunetan.',
  'stadium.merchandising_title': 'Denda Ofizialak',
  'stadium.mod_cafeteria': 'Kafetegiak eta Ostalaritza',
  'stadium.mod_level': '{level}/5 Maila',
  'stadium.mod_max': 'Gehienezko Maila',
  'stadium.mod_merch': 'Denda Ofizialak',
  'stadium.mod_parking': 'Estadioko Aparkalekua',
  'stadium.modules_desc': 'Hobetu instalazio komertzialak partida bakoitzeko zale bakoitzeko diru-sarrerak handitzeko.',
  'stadium.modules_title': 'Modulu Komertzialak eta Ustiapena',
  'stadium.parking_desc': 'Eserleku bakoitzeko sarrerak eta zaleen erosotasuna hobetzen ditu.',
  'stadium.parking_title': 'Estadioko Aparkalekua',
  'stadium.passed_tier': 'Gaindituta',
  'stadium.premium_tier': 'Premium',
  'stadium.pricing_desc': 'Egokitu sarrera orokorren batez besteko prezioa eskaeraren eta taldearen formaren arabera txarteldegia optimizatzeko.',
  'stadium.pricing_title': 'Sarreren Prezioak Zehaztea',
  'stadium.proj_commercial': 'Diru-sarrera Komertzialak (Aparkalekua/Taberna):',
  'stadium.proj_tickets': 'Txarteldegiko Diru-sarrera Aurreikusiak:',
  'stadium.projected_commercial': 'Merkataritza Diru-sarrerak (Aparkalekua/Taberna)',
  'stadium.projected_tickets': 'Proiektatutako Txarteldegi Sarrerak',
  'stadium.reserved_funds': 'Funts Erreserbatua',
  'stadium.seats': 'Eserlekuak',
  'stadium.sim_title': 'Aurreikusitako Edukieraren Simulazioa',
  'stadium.staff_desc': 'Prestakuntza-arlo bakoitzak taldearen errendimendua areagotzen du partida-motorrean.',
  'stadium.staff_fitness': 'Atzelarien Entrenatzailea',
  'stadium.staff_gk': 'Atezainen Entrenatzailea',
  'stadium.staff_shooting': 'Aurrelarien Entrenatzailea',
  'stadium.staff_tech': 'Erdilarien Entrenatzailea',
  'stadium.staff_title': 'Talde Teknikoa eta Prestatzaileak',
  'stadium.staff_upgrade': '+0.5★ (0.5 M€)',
  'stadium.standard_tier': 'Estandarra',
  'stadium.stands_level': 'Harmailen Maila',
  'stadium.sub_balance': 'Uneko Kreditu Saldoa:',
  'stadium.sub_cost': 'Hileko Kuotaren Kostua:',
  'stadium.sub_desc': 'Hileko kuotaren eta kredituen kudeaketa partidetarako eta simulazio aurreratuetarako.',
  'stadium.sub_pay': 'Hileko Kuota Ordaindu (-100 CR)',
  'stadium.sub_title': 'Harpidetza eta Kredituak (CR)',
  'stadium.subtitle': 'Prezioak, edukiera, modulu komertzialak, talde teknikoa, banku-kredituak eta liburu nagusia.',
  'stadium.surpassed_tier': 'Gaindituta',
  'stadium.sync_server': 'Datuak zerbitzariarekin sinkronizatu',
  'stadium.tab_economy': 'Ekonomia',
  'stadium.tab_stadium': 'Estadioa',
  'stadium.tab_staff': 'Staff',
  'stadium.ticket_desc': 'Doitu sarrera orokorren batez besteko prezioa txarteldegia optimizatzeko eskaeraren eta taldearen formaren arabera.',
  'stadium.ticket_title': 'Sarreren Prezioen Ezarpena',
  'stadium.title': 'Estadioa eta Finantza Azpiegitura',
  'stadium.total_capacity': 'Estadioaren Edukiera Osoa:',
  'stadium.treasury': 'Klubaren Diruzaintza (EUR)',
  'stadium.upgrade_btn': 'Handitu',
  'stadium.upgrade_level_btn': 'Maila Hobetu',
  'stadium.upgrade_module': 'Maila Hobetu ({cost} M€)',
  'staff.annual_cost': 'Urteko Kostua',
  'staff.desc': 'Klubaren lehiakortasun errendimendua bultzatzen duten talde tekniko ofiziala eta prestatzaile espezializatuak.',
  'staff.fitness_coach': 'Atzelarien Entrenatzailea',
  'staff.goalkeeping_coach': 'Atezainen Entrenatzailea',
  'staff.modifier': 'Aldatzailea',
  'staff.on_payroll': 'prestatzaile nominan',
  'staff.quality_level': 'Maila / Kalitatea',
  'staff.shooting_coach': 'Aurrelarien Entrenatzailea',
  'staff.tactical_coach': 'Erdilarien Entrenatzailea',
  'staff.title': 'Talde Teknikoa eta Prestatzaileak',

  // Coaches (Entrenatzaileak)
  'coaches.title': 'Entrenatzaileak',
  'coaches.tab_market': 'Entrenatzaileen Merkatua',
  'coaches.tab_my_coach': 'Nire Entrenatzailea',
  'coaches.tab_offers': 'Egindako Eskaintzak',
  'coaches.daily_market': 'Eguneko Entrenatzaileen Merkatua',
  'coaches.daily_market_desc': 'Gaur eskuragarri dauden teknikari libreak taldearen lerroak hobetzeko.',
  'coaches.closes_at': 'Lizitazioaren itxiera',
  'coaches.time_left': 'Gainerako denbora',
  'coaches.closed': 'Merkatua Itxita (adjudikazioa prozesatzen)',
  'coaches.empty_market': 'Gaur ez dago entrenatzailerik merkatuan',
  'coaches.empty_market_desc': 'Jardunaldi honetarako ez dago teknikari libre gehiagorik. Hurrengo datan berrituko da.',
  'coaches.attack': 'Erasoa',
  'coaches.midfield': 'Erdigunea',
  'coaches.defense': 'Defentsa',
  'coaches.bonus_sum_info': 'Hobekuntza taktikoak guztira %15 gehitzen dute hiru lerroen artean.',
  'coaches.submit_offer': 'Eskaintza Egin',
  'coaches.modify_offer': 'Eskaintza Aldatu',
  'coaches.cancel_offer': 'Eskaintza Ezeztatu',
  'coaches.has_pending_offer': 'Teknikari honentzako eskaintza aktibo bat duzu',
  'coaches.offer_modal_title': 'Entrenatzailearen Aldeko Eskaintza',
  'coaches.signing_bonus': 'Fitxaketa Prima (€)',
  'coaches.annual_salary': 'Denboraldiko Soldata (€)',
  'coaches.release_clause': 'Erreskisioko Klausula (€)',
  'coaches.score': 'Puntuazioa',
  'coaches.score_formula': 'Puntuazioa = Prima × %60 + Soldata × %40',
  'coaches.score_explanation': 'Puntuazio altuenak irabazten du. Berdinketa kasuan, lehen jasotakoak irabazten du.',
  'coaches.disclaimer_bonus': 'Prima fitxaketa adjudikatzean kobratuko da; eskaintza egiteak ez du saldoa erreserbatzen.',
  'coaches.disclaimer_salary': 'Soldata denboraldiko gainerako jardunaldietan hainbanatuta kobratuko da.',
  'coaches.disclaimer_replacement': 'Ordezkatze oharra: irabaziz gero eta entrenatzaile aktiborik baduzu, bere kontratua deuseztatuko da eta ordaindu gabeko jardunaldiak indemnizatuko dira.',
  'coaches.disclaimer_multiple': 'Klub eta liga bakoitzeko entrenatzaile-eskaintza aktibo bakarra izan dezakezu. Aldatzeko, epea amaitu aurretik bertan behera utzi eta beste bat aurkeztu; jatorrizko iritsiera-lehentasuna galduko duzu.',
  'coaches.offers_unverified': 'Ezin duzu eskaintzarik egin zure eskaintzak egiaztatu arte.',
  'coaches.retry': 'Saiatu berriro',
  'coaches.checking_offers': 'Eskaintza aktiboak egiaztatzen…',
  'coaches.uncertain_offer': 'Ezin izan da bidalketa berretsi. Saiatu berriro eskaintza eta zenbateko berberekin beste bat aurkeztu aurretik.',
  'coaches.active_offer': 'Eskaintza aktibo bat duzu',
  'coaches.awaiting_resolution': 'Ebazpenaren zain: ezin duzu bertan behera utzi edo beste eskaintzarik aurkeztu ebatzi arte.',
  'coaches.cancel_before_new': 'Entrenatzailea edo zenbatekoak aldatzeko, utzi eskaintza hau bertan behera epea amaitu aurretik.',
  'coaches.view_offer': 'Ikusi eskaintza aktiboa',
  'coaches.status_pending': 'Zain',
  'coaches.status_won': 'Adjudikatua',
  'coaches.status_lost': 'Galdua',
  'coaches.status_insufficient_funds': 'Saldo nahikorik ez',
  'coaches.status_cancelled': 'Utzita',
  'coaches.active_coach': 'Klubeko Entrenatzailea',
  'coaches.active_coach_desc': 'Kontratu-baldintzak eta taldeari aplikatutako hobekuntza taktikoak.',
  'coaches.no_active_coach': 'Ez dago entrenatzailerik kontratatuta',
  'coaches.no_active_coach_desc': 'Klubak ez du gaur egun entrenatzaile aktiborik (+%0 hobekuntza).',
  'coaches.contract_history': 'Kontratuen Historia',
  'coaches.contract_active': 'Indarrean',
  'coaches.contract_terminated': 'Deuseztatua',
  'coaches.contract_expired': 'Iraungia',
  'coaches.go_to_market': 'Entrenatzaileen Merkatura Joan',
  'coaches.ledger_signing_bonus': 'Entrenatzailearen fitxaketa-prima',
  'coaches.ledger_termination': 'Entrenatzailea kaleratzeagatiko kalte-ordaina',
  'coaches.ledger_salary': 'Entrenatzailearen soldata',
  'coaches.match_frozen_notice': 'Entrenatzailea jardunaldiaren hasieran izozten da.',
  'coaches.match_included_notice': 'Kalkulatutako potentziek entrenatzaile honen hobekuntza barne hartzen dute.',
};
